import Modal from 'react-bootstrap/Modal';

function CommonSuccessModal(props) {

  const { showModal, handleClose, message, status } = props;
  
  return (

    <>
      <Modal show={showModal} style={{ padding: '20px', top: '35%' }} onHide={handleClose}>
        <Modal.Header closeButton={true} style={{ padding: '20px' }} />

        <Modal.Body >
          <p className={status ? 'success-modal-text' : 'error-modal-text'}>
            {message}
          </p>
        </Modal.Body>
      </Modal>

    </>
  );
}

export default CommonSuccessModal;